import Txt from 'components/atoms/Txt/Txt';
import React from 'react';

export type Props = {
  className?: string;
  redemptionsError: string;
};

export default function PaypalErrorMessage({ className, redemptionsError }: Props) {
  const message = (() => {
    switch (redemptionsError) {
      case 'cancelled':
        return (
          <Txt bold component="p">
            You cancelled the PayPal linking process. If you did not mean to do this, please try
            again.
          </Txt>
        );

      case 'contact':
        return (
          <>
            <Txt bold component="p">
              We couldn&apos;t contact PayPal&apos;s services to link your account. Please try again
              later.
            </Txt>
            <Txt component="p">
              We have detected problems on PayPal&apos;s side. These should hopefully be resolved
              soon, please try again later.
            </Txt>
          </>
        );

      case 'paypal_in_use':
        return (
          <>
            <Txt bold component="p">
              PayPal account is already in use on another user account.
            </Txt>
            <Txt component="p">
              A single PayPal account can only be linked to a single user account.
            </Txt>
          </>
        );

      case 'country':
        return (
          <>
            <Txt bold component="p">
              Sorry, you can only link a PayPal account for the country you&apos;re in.
            </Txt>{' '}
            <Txt component="p">
              Our service is only available in selected countries. Ensure your verifies Paypal
              address relates to the country you are in, and that you are in a country where we
              operate.
            </Txt>
          </>
        );

      case 'verify':
        return (
          <>
            <Txt bold component="p">
              PayPal have let us know your account is not fully verified. To keep your rewards safe,
              you need a verified PayPal account - this requires a confirmed email address and bank
              account added to your PayPal account. Please verify your account before linking it to
              your account.
            </Txt>
            <Txt component="p">
              Follow the steps provided by{' '}
              <a
                href={
                  'https://www.paypal.com/uk/cshelp/article/how-do-i-verify-my-paypal-account-help434'
                }
              >
                PayPal
              </a>{' '}
              to verify your account.
            </Txt>
          </>
        );

      case 'reverification-001':
        return (
          <>
            <Txt bold component="p">
              PayPal has notified us that this PayPal account is no longer verified. Please contact
              PayPal in order to get this account verified, or link a different verified PayPal
              account. You will not be able to redeem to PayPal or gift cards until you have linked
              a verified PayPal account.
            </Txt>
            <Txt component="p">
              Follow the steps provided by{' '}
              <a
                href={
                  'https://www.paypal.com/uk/cshelp/article/how-do-i-verify-my-paypal-account-help434'
                }
              >
                PayPal
              </a>{' '}
              to verify your account.
            </Txt>
          </>
        );

      case 'reverification-002':
        return (
          <>
            <Txt bold component="p">
              PayPal has notified us that the selected PayPal account is no longer verified. You can
              still redeem to PayPal or gift cards using your other PayPal account(s) if they are
              verified. If you would like to continue using the selected PayPal account, then please
              contact PayPal in order to get this account verified.
            </Txt>
            <Txt component="p">
              Follow the steps provided by{' '}
              <a
                href={
                  'https://www.paypal.com/uk/cshelp/article/how-do-i-verify-my-paypal-account-help434'
                }
              >
                PayPal
              </a>{' '}
              to verify the account you are trying to cash out to.
            </Txt>
          </>
        );

      case 'address':
        return (
          <>
            <Txt bold component="p">
              The address from your PayPal account is not valid. Please update your PayPal account
              and try linking your account again.
            </Txt>
            <Txt component="p">
              Follow the steps provided by{' '}
              <a
                href={
                  'https://www.paypal.com/us/cshelp/article/how-do-i-add-change-or-remove-a-street-address-on-my-paypal-account-pcc138'
                }
              >
                PayPal
              </a>{' '}
              to update your address.
            </Txt>
          </>
        );

      case 'general':
        return (
          <>
            <Txt bold component="p">
              We are sorry, something went wrong. Please try again.
            </Txt>
            <Txt component="p">
              Something went wrong while linking your account. Please try and link your PayPal
              account again. If this issue persists please contact support.
            </Txt>
          </>
        );

      default:
        return null;
    }
  })();

  if (!message) return null;

  return <div className={className}>{message}</div>;
}
